<template>
  <div class="retailer-search-location-fi">
    <retailer-search-input-fi
      ref="retailerSearchLocationInput"
      :value="location"
      class="retailer-search-location-fi__input"
      :user-location-loading="userLocationLoading"
      :user-location-error="locationError"
      @input="searchPlaces"
      @search="selectPlace(places[0])"
      @clear="$emit('location-changed', null)"
      @user-location="useUserLocation"
      @keyup-enter="selectPlace(places[0])"
    />

    <div
      v-if="showPlaces && places.length > 0"
      class="retailer-search-location-fi__search-results"
    >
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-for="place in places"
        :key="place.place_id"
        class="retailer-search-location-fi__search-results__item"
        data-test="retailer-search-location-item"
        @click="selectPlace(place)"
        v-html="highlight(place.description)"
      />
      <!-- eslint-enable vue/no-v-html -->
    </div>
  </div>
</template>

<script>
import escapeStringRegexp from 'escape-string-regexp';

import RetailerSearchInputFi from './retailer-search-input-fi/RetailerSearchInputFi';

export default {
  name: 'RetailerSearchLocationFi',
  components: {
    RetailerSearchInputFi,
  },
  props: {
    autocompleteOptions: {
      type: Object,
      default: () => ({}),
    },
    loc: {
      type: Object,
      default: null,
    },
    locationError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['location-changed', 'user-location-error'],
  data() {
    return {
      location: null,
      places: [],
      showPlaces: false,
      selected: {},
      service: null,
      userlocation: {},
      userLocationLoading: false,
      activePlace: false,
      googleMaps: {
        lat: 0,
        lng: 0,
      },
    };
  },
  watch: {
    google() {
      this.mapsInit();
    },
    location() {
      if (this.service === null) {
        this.mapsInit();
      }
      if (!this.location || this.location.length === 0) {
        this.clearForm();
      }
    },
    loc(val) {
      this.location = val?.description || '';
    },
  },
  methods: {
    mapsInit() {
      this.service = new window.google.maps.places.AutocompleteService();
    },
    async searchPlaces(value) {
      this.location = value;
      if (this.activePlace) {
        this.activePlace = false;
        return;
      }

      try {
        if (this.service && this.location) {
          const results = await this.service.getPlacePredictions({
            input: this.location,
            componentRestrictions: this.autocompleteOptions?.componentRestrictions,
          });
          const { predictions } = results;
          this.places = predictions;
          this.showPlaces = true;
        } else {
          this.$emit('location-changed', null);
        }
      } catch (error) {
        console.error(error);
      }
    },
    getLatLong(place) {
      try {
        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode(
          {
            placeId: place.place_id,
          },
          async (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
              this.googleMaps.lat = await results[0].geometry.location.lat();
              this.googleMaps.lng = await results[0].geometry.location.lng();
              this.$emit('location-changed', {
                description: place.description,
                ...this.googleMaps,
              });
            }
          },
        );
      } catch (error) {
        console.error(`Error getting LatLon coords: ${error}`);
      }
    },
    async selectPlace(place) {
      if (place) {
        this.activePlace = true;
        this.location = place.description;
        this.selected.description = place.description;
        this.selected.location_id = place.place_id;
        this.getLatLong(place);
        this.showPlaces = false;
      }
    },
    clearForm() {
      this.activePlace = false;
      this.location = '';
      this.selected = {};
      this.places = [];
      this.showPlaces = false;
    },
    highlight(text) {
      let highlighted = text;
      this.location.split(/\s+/).forEach((fragment) => {
        if (!fragment) {
          return;
        }
        const locationRegexp = new RegExp(escapeStringRegexp(fragment), 'i');
        highlighted = highlighted.replace(
          locationRegexp,
          (match) => `<span class="fi-semibold">${match}</span>`,
        );
      });
      return highlighted;
    },
    useUserLocation() {
      this.userLocationLoading = true;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: latlng }, (results, status) => {
              if (status === 'OK') {
                if (results[0]) {
                  const { formatted_address, geometry } = results[0];
                  const userLocation = {
                    location: formatted_address,
                    lat: parseFloat(geometry.location.lat()),
                    lng: parseFloat(geometry.location.lng()),
                  };
                  this.activePlace = true;
                  this.location = userLocation.location;
                  this.places = [];
                  this.showPlaces = false;
                  this.googleMaps.lat = userLocation.lat;
                  this.googleMaps.lng = userLocation.lng;
                  this.$emit('location-changed', {
                    description: userLocation.location,
                    ...this.googleMaps,
                    userloaction: true,
                  });
                } else {
                  console.error('No results found');
                }
              } else {
                console.error(status);
              }
              this.userLocationLoading = false;
            });
          },
          (error) => {
            this.userLocationLoading = false;
            this.$emit('user-location-error', error.message);
            console.error(error.message);
          },
        );
      } else {
        this.userLocationLoading = false;
        this.$emit('user-location-error', 'navigator geolocation not defined');
        console.error('navigator geolocation not defined');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './retailer-search-location-fi';
</style>
